export default __webpack_public_path__ + "static/ogg-image-default-8ca09a6862229e4a3fcdd636a8eed3f5.png";